import { DailyBulkEntryModal } from "./DailyBulkEntryModal";
import { SimpleBulkEntryModal } from "./SimpleBulkEntryModal";
import type { EntryDraftRecord } from "../../api/draftApi";

type BulkModuleKey = "DailyEntry" | "CashEntry" | "StatementEntry";

export function BulkEntryModal({
  open,
  onClose,
  onSaved,
  moduleKey = "DailyEntry",
  draft,
  onDraftSaved
}: {
  open: boolean;
  onClose: () => void;
  onSaved: () => void;
  moduleKey?: BulkModuleKey;
  draft?: EntryDraftRecord | null;
  onDraftSaved?: () => void;
}) {
  if (moduleKey === "CashEntry" || moduleKey === "StatementEntry") {
    return <SimpleBulkEntryModal open={open} onClose={onClose} onSaved={onSaved} moduleKey={moduleKey} draft={draft} onDraftSaved={onDraftSaved} />;
  }
  return <DailyBulkEntryModal open={open} onClose={onClose} onSaved={onSaved} draft={draft} onDraftSaved={onDraftSaved} />;
}
